"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllAlphaUnlocks = exports.getAlphaUnlocksByUnlockDateAndAddress = exports.getAlphaUnlocksByAddress = exports.getAlphaUnlocksByUnlockDate = exports.putAlphaUnlocksToDynamoDB = void 0;
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const client = new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
const ALPHA_UNLOCK_TABLE_NAME = process.env.ALPHA_UNLOCK_TABLE_NAME;
const putAlphaUnlocksToDynamoDB = async (items, tableName) => {
    const mainTableName = tableName ? tableName : ALPHA_UNLOCK_TABLE_NAME;
    const batches = [];
    while (items.length > 0) {
        // DynamoDB BatchWrite supports a max of 25 items per batch
        const batch = items.splice(0, 25);
        const requestItems = batch.map((holder) => ({
            PutRequest: {
                Item: {
                    unlockDate: {
                        S: new Date(holder.timestampMs).toISOString(),
                    }, // Partition key
                    address: { S: holder.address }, // Sort key
                    amount: { S: holder.tokens }, // Numeric balance
                    unlockTimestamp: { S: holder.timestampMs.toString() },
                },
            },
        }));
        const params = {
            RequestItems: {
                [mainTableName ? mainTableName : "Alphafi-unlock"]: requestItems,
            },
        };
        batches.push(client.send(new client_dynamodb_1.BatchWriteItemCommand(params)));
    }
    // Execute all batches
    await Promise.all(batches);
    console.log("All items have been inserted into DynamoDB.");
};
exports.putAlphaUnlocksToDynamoDB = putAlphaUnlocksToDynamoDB;
const getAlphaUnlocksByUnlockDate = async (unlockDate, tableName) => {
    const thisTableName = tableName ? tableName : ALPHA_UNLOCK_TABLE_NAME;
    const command = new client_dynamodb_1.QueryCommand({
        TableName: thisTableName,
        KeyConditionExpression: "unlockDate = :unlockDate", // Partition key condition
        ExpressionAttributeValues: {
            ":unlockDate": { S: unlockDate },
        },
    });
    try {
        const response = await client.send(command);
        return response.Items;
    }
    catch (error) {
        console.error("Error fetching items by unlockDate:", error);
        throw error;
    }
};
exports.getAlphaUnlocksByUnlockDate = getAlphaUnlocksByUnlockDate;
const getAlphaUnlocksByAddress = async (address, tableName) => {
    const thisTableName = tableName ? tableName : ALPHA_UNLOCK_TABLE_NAME;
    const command = new client_dynamodb_1.QueryCommand({
        TableName: thisTableName,
        KeyConditionExpression: "address = :address", // sort key condition
        ExpressionAttributeValues: {
            ":address": { S: address },
        },
    });
    try {
        const response = await client.send(command);
        return response.Items;
    }
    catch (error) {
        console.error("Error fetching items by address:", error);
        throw error;
    }
};
exports.getAlphaUnlocksByAddress = getAlphaUnlocksByAddress;
const getAlphaUnlocksByUnlockDateAndAddress = async (unlockDate, address, tableName) => {
    const mainTableName = tableName ? tableName : ALPHA_UNLOCK_TABLE_NAME;
    const command = new client_dynamodb_1.QueryCommand({
        TableName: mainTableName,
        KeyConditionExpression: "unlockDate = :unlockDate AND address = :address", // Partition and Sort key condition
        ExpressionAttributeValues: {
            ":unlockDate": { S: unlockDate },
            ":address": { S: address },
        },
    });
    try {
        const response = await client.send(command);
        if (response && response.Items && response.Items.length > 0) {
            return response.Items[0];
        }
        else {
            console.log("No matching item found");
            return null;
        }
    }
    catch (error) {
        console.error("Error fetching item by unlockDate and address:", error);
        throw error;
    }
};
exports.getAlphaUnlocksByUnlockDateAndAddress = getAlphaUnlocksByUnlockDateAndAddress;
const getAllAlphaUnlocks = async (tableName) => {
    const thisTableName = tableName ? tableName : ALPHA_UNLOCK_TABLE_NAME;
    const command = new client_dynamodb_1.ScanCommand({
        TableName: thisTableName,
    });
    try {
        const response = await client.send(command);
        return response.Items; // Returning all items from the table
    }
    catch (error) {
        console.error("Error fetching all items:", error);
        throw error;
    }
};
exports.getAllAlphaUnlocks = getAllAlphaUnlocks;
//# sourceMappingURL=dbFunctions.js.map